import { isString } from '../string/isString';
export function exhaustiveCheck(param, errorMessage) {
    const error = isString(errorMessage) ? new Error(errorMessage) : errorMessage;
    throw error;
}
